
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import * as Sentry from "@sentry/react";
import { HOST } from "Constant/Constant";
import { getQueryString } from "Constant/utils";
import { getInquiries } from "store/reducer/inquiry";

export const inquiryApi = createApi({
  reducerPath: "inquiryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getInquiries: builder.mutation({
      query: (getQueryParams) => {
        return {
          url: `/get-inquiries${getQueryString(getQueryParams)}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled;
          dispatch(
            getInquiries({
              data: response.data,
            })
          );
        } catch (error) {
          console.error(">>>>>getInquiries error", error);
          Sentry.addBreadcrumb({ category: "api", message: "getInquiries mutation failed", level: "error", data: { error } });
          dispatch(getInquiries({ data: [] }));
        }
      },
    }),

    siteGenerateApi: builder.mutation({
      query: (webCllientId) => {
        return {
          url: '/generate-site',
          method: "POST",
          body: {
            webClientId: webCllientId,
          },
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),

    siteDeclineApi: builder.mutation({
      query: (declineRequest) => {
        return {
          url: '/decline-inquiry',
          method: "POST",
          body: {
            webClientId: declineRequest?.webClientid,
            reason: declineRequest?.reason,
          },
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),

    getInquiryById: builder.query({
      query: (id) => ({
        url: `/get-inquiries/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    }),

    updateInquiry: builder.mutation({
      query: (body) =>
      {
        const {id, ...otherBody} = body;
        return {
          url: `/edit-inquiry/${id}`,
          method: "PATCH",
          body: otherBody,
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      },
    }),

    getFileUpload: builder.mutation({
      query: (body) => ({
        url: `ico/upload`,
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          siteid: "10000",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      }),
    }),
  }),
});

export const {
  useGetInquiriesMutation,
  useSiteDeclineApiMutation,
  useSiteGenerateApiMutation,
  useGetFileUploadMutation,
  useGetInquiryByIdQuery,
  useUpdateInquiryMutation,
} = inquiryApi;
